import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-my-app-tile',
  templateUrl: './my-app-tile.component.html',
  styleUrls: ['./my-app-tile.component.scss'],
})
export class MyAppTileComponent {
  @Input() iconSrc = '';
  @Input() iconAlt = '';
  @Input() title = '';
  @Input() titleClassName = 'my-app-tile__title--default';
  @Input() subtitle = '';
  @Input() hideTitle = false;
  @Input() iconClassName = '';
  /** Visual treatment for product tiles (e.g. Aya brand card). */
  @Input() tileVariant: 'default' | 'aya' | 'ayaProduct' = 'default';
  @Input() largeLogo = false;
  @Input() preview = false;
  @Input() previewVariant: 'default' | 'purple' = 'default';
  @Input() disabled = false;
  @Output() tileClick = new EventEmitter<void>();

  onClick(): void {
    if (this.disabled) {
      return;
    }
    this.tileClick.emit();
  }
}
